//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "bulkyCreateNewModuleSession",
  data: function data() {
    return {
      exlFile: '',
      moduleSessionList: null,
      tableFields: {
        moduleName: { label: 'Module' },
        sessionTimeRaw: { label: 'Session Time' },
        seatTotal: { label: 'Total Seat' },
        roomId: { label: 'Room ID' },
        trainerName: { label: 'Trainer' },
        language: { label: 'Language' },
        errorInfo: { label: 'Error Info' }
      }
    };
  },

  methods: {
    printFile: function printFile(fileInput) {
      console.log('\n\n ===== Bulky ModuleSession <|-- Excel File ====\n', this.exlFile, '\n -------------');
      console.log('\n\n ===== Bulky ModuleSession <|-- File Input ====\n', fileInput, '\n -------------');
    },
    bulkyCreate: function bulkyCreate() {
      console.log('\n\n ==== Bulky Creation <|-- bulkyCreate() ====\n', this.exlFile, '\n ----------');

      var _this = this;

      var fileReader = new FileReader();

      fileReader.onload = function (ev) {

        var moduleSessions = [];
        var data = ev.target.result;
        var workbook = XLSX.read(data, { type: 'binary' });

        var fromTo = '';

        for (var sheet in workbook.Sheets) {
          if (workbook.Sheets.hasOwnProperty(sheet)) {
            fromTo = workbook.Sheets[sheet]['!ref'];
            console.log(fromTo);
            moduleSessions = moduleSessions.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
            break;
          }
        }
        _this.moduleSessionList = moduleSessions;
        console.log('\n\n ====== Bulky ModuleSession <|-- _this.moduleSessionList ====\n', _this.moduleSessionList, '\n ------------------------');
        _this.$emit('bulkyModuleSessionCreate', _this.moduleSessionList);
      };

      fileReader.readAsBinaryString(this.exlFile);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/BulkyCreateNewModuleSession.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/home/ubuntu/BookingSystemV2/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/dashboard/management/BulkyCreateNewModuleSession.vue
// module chunks = 0